import React from "react";
import styled from "styled-components";

import Layout from "@components/Layout";
import SchoolPartnersAddForm from "./SchoolPartnersAddForm";

import { Container } from "@styles/grid";

const Content = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 3rem 5.5rem 5.5rem;
`;

const SchoolsPartnersAdd = () => {
  return (
    <Layout pageTitle="Add School Partners">
      <Container>
        <Content>
          <SchoolPartnersAddForm />
        </Content>
      </Container>
    </Layout>
  );
};

export default SchoolsPartnersAdd;
